<info-box>
    <ng-container *ngIf="isSelfAdvertising">
        <h6>Jak realizowana jest promocja w Twoim sklepie?</h6>
        <p>Proces tworzenia kampanii rozpoczyna się od selekcji produktów do promocji.</p>
        <p>Użyj wyszukiwarki, wprowadź nazwę lub numer EAN wybranego produktu i dodaj go do kampanii. Wybrane produkty
            będą wyświetlane w ramach przestrzeni reklamowej, którą zintegrowałeś jako Partner Retail Media Network.</p>
    </ng-container>
    <ng-container *ngIf="!isSelfAdvertising">
        <h6>Jak działa lista produktów?</h6>
        <p>Tworzenie kampanii w Retail Media Network rozpoczyna się od wyboru produktów, które będą w niej promowane.</p>
        <p>Twoja kampania będzie kierowała na karty produktów w sklepach obecnych w Retail Media Network. Skorzystaj z
            wyszukiwarki, wpisz nazwę wybranego produktu lub jego numer EAN i dodaj go do tworzonej kampanii.</p>
    </ng-container>
    <a
        mat-flat-button
        color="primary"
        href="https://pomoc.onetads.pl"
        target="_blank"
    ><mat-icon class="icon material-icons-outlined">live_help</mat-icon>pomoc</a>
</info-box>
